import { deleteRequest, getRequest, postRequest, putRequest } from '@bo-apis/axios';

const getTermsManagement = ({ siteNumber, termsType, applyStartDateTime }) =>
  getRequest({
    url: '/api/v1/system/terms',
    params: { siteNumber, termsType, applyStartDateTime },
  });

const getTermsManagementByTermsNo = (termsNo) =>
  getRequest({
    url: `/api/v1/system/terms/${termsNo}`,
    params: { termsNo },
  });

const getTermsManagementList = ({ form, pageable }) =>
  postRequest({
    url: '/api/v1/system/terms/get-terms-management-list',
    params: { ...pageable },
    data: { ...form },
  });

const getSiteTermsManagementList = (siteNumber) =>
  getRequest({
    url: `/api/v1/system/terms/site/${siteNumber}`,
  });

const deleteTermsManagementList = (data) =>
  deleteRequest({
    url: '/api/v1/system/terms',
    data,
  });

const createTermsManagement = (data) =>
  postRequest({
    url: '/api/v1/system/terms',
    data,
  });

const updateTermsManagement = (data) =>
  putRequest({
    url: '/api/v1/system/terms',
    data,
  });

const checkPeriodDuplicationTerms = (data) =>
  getRequest({
    url: '/api/v1/system/terms/check-terms-management',
    params: {
      ...data,
    },
  });
const checkExistsStartDateGrater = (data) =>
  getRequest({
    url: '/api/v1/system/terms/check-date-grater-terms-management',
    params: {
      ...data,
    },
  });

export default {
  getTermsManagement,
  getTermsManagementByTermsNo,
  getTermsManagementList,
  getSiteTermsManagementList,
  createTermsManagement,
  updateTermsManagement,
  deleteTermsManagementList,
  checkPeriodDuplicationTerms,
  checkExistsStartDateGrater,
};
